export const organisationConstants = {


    //demographic download
    REQUEST_DEMOGRAPHIC_DOWNLOAD: 'REQUEST_DEMOGRAPHIC_DOWNLOAD',
    RESPONSE_DEMOGRAPHIC_DOWNLOAD: 'RESPONSE_DEMOGRAPHIC_DOWNLOAD',
    ERROR_DEMOGRAPHIC_DOWNLOAD: 'ERROR_DEMOGRAPHIC_DOWNLOAD',


    //update group mandate
    REQUEST_GROUP_MANDATE_UPDATE: 'REQUEST_GROUP_MANDATE_UPDATE',
    RESPONSE_GROUP_MANDATE_UPDATE: 'RESPONSE_GROUP_MANDATE_UPDATE',
    ERROR_GROUP_MANDATE_UPDATE: 'ERROR_GROUP_MANDATE_UPDATE',

    //group report list
    REQUEST_GROUP_REPORT_LIST_PDF: 'REQUEST_GROUP_REPORT_LIST_PDF',
    RECIEVE_GROUP_REPORT_LIST_PDF: 'RECIEVE_GROUP_REPORT_LIST_PDF',
    ERROR_GROUP_REPORT_LIST_PDF: 'ERROR_GROUP_REPORT_LIST_PDF',
    
    //group report list
    REQUEST_GROUP_REPORT_LIST_ASSESSOR: 'REQUEST_GROUP_REPORT_LIST_ASSESSOR',
    RECIEVE_GROUP_REPORT_LIST_ASSESSOR: 'RECIEVE_GROUP_REPORT_LIST_ASSESSOR',
    ERROR_GROUP_REPORT_LIST_ASSESSOR: 'ERROR_GROUP_REPORT_LIST_ASSESSOR',

    // group instrument list
    REQUEST_GROUP_REPORT_LIST_INSTRUMENT: 'REQUEST_GROUP_REPORT_LIST_INSTRUMENT',
    RECIEVE_GROUP_REPORT_LIST_INSTRUMENT: 'RECIEVE_GROUP_REPORT_LIST_INSTRUMENT',
    ERROR_GROUP_REPORT_LIST_INSTRUMENT: 'ERROR_GROUP_REPORT_LIST_INSTRUMENT',

    //group report list
    REQUEST_GROUP_REPORT_LIST: 'REQUEST_GROUP_REPORT_LIST',
    RECIEVE_GROUP_REPORT_LIST: 'RECIEVE_GROUP_REPORT_LIST',
    ERROR_GROUP_REPORT_LIST: 'ERROR_GROUP_REPORT_LIST',

     //get competency metric prefill list
     REQUEST_PREFILL_COMPETENCY: 'REQUEST_PREFILL_COMPETENCY',
     RECIEVE_PREFILL_COMPETENCY: 'RECIEVE_PREFILL_COMPETENCY',
     ERROR_PREFILL_COMPETENCY: 'ERROR_PREFILL_COMPETENCY',

    //get attribute list
    REQUEST_ATTRIBUTE_LIST: 'REQUEST_ATTRIBUTE_LIST',
    RECIEVE_ATTRIBUTE_LIST: 'RECIEVE_ATTRIBUTE_LIST',
    ERROR_ATTRIBUTE_LIST: 'ERROR_ATTRIBUTE_LIST',

    //get competency list
    REQUEST_COMPETENCY: 'REQUEST_COMPETENCY',
    RECIEVE_COMPETENCY: 'RECIEVE_COMPETENCY',
    ERROR_COMPETENCY: 'ERROR_COMPETENCY',

    //get instrument list
    REQUEST_INSTRUMENT: 'REQUEST_INSTRUMENT',
    RECIEVE_INSTRUMENT: 'RECIEVE_INSTRUMENT',
    ERROR_INSTRUMENT: 'ERROR_INSTRUMENT',

    //request
    REQUEST_ORGANISATION: 'REQUEST_ORGANISATION',
    RECIEVE_ORGANISATION: 'RECIEVE_ORGANISATION',
    ERROR_ORGANISATION: 'ERROR_ORGANISATION',

    //credits
    REQUEST_CREDITS: 'REQUEST_ORG_CREDITS',
    RECEIVE_CREDITS: 'RECEIVE_ORG_CREDITS',
    CREDITS_ERROR: 'CREDITS_ORG_ERROR',

    //admin list
    REQUEST_ORG_ADMIN: 'REQUEST_ORG_ADMIN',
    RECEIVE_ORG_ADMIN: 'RECEIVE_ORG_ADMIN',
    ADMIN_ORG_ERROR: 'ADMIN_ORG_ERROR',

    //image upload
    ORG_REQUEST_UPLOAD: 'ORG_REQUEST_UPLOAD',
    ORG_RESPONSE_UPLOAD: 'ORG_RESPONSE_UPLOAD',
    ORG_ERROR_UPLOAD: 'ORG_ERROR_UPLOAD',

    //remove uploaded image
    ORG_REQUEST_DELETE_UPLOAD: 'ORG_REQUEST_DELETE_UPLOAD',
    ORG_RESPONSE_DELETE_UPLOAD: 'ORG_RESPONSE_DELETE_UPLOAD',
    ORG_ERROR_DELETE_UPLOAD: 'ORG_ERROR_DELETE_UPLOAD',

    //request add organisation
    REQUEST_ADD_ORG: 'REQUEST_ADD_ORG',
    RESPONSE_ADD_ORG: 'RESPONSE_ADD_ORG',
    REQUEST_ERROR_ORG: 'REQUEST_ERROR_ORG',

    //request del organisation
    REQUEST_DEL_ORG: 'REQUEST_DEL_ORG',
    RESPONSE_DEL_ORG: 'RESPONSE_DEL_ORG',
    ERROR_DEL_ORG: 'ERROR_DEL_ORG',

    //request edit organisation
    REQUEST_EDIT_ORG: 'REQUEST_EDIT_ORG',
    RESPONSE_EDIT_ORG: 'RESPONSE_EDIT_ORG',
    ERROR_EDIT_ORG: 'ERROR_EDIT_ORG',

    //request add admin 
    REQUEST_ADD_ADMIN_ORG: 'REQUEST_ADD_ADMIN_ORG',
    RESPONSE_ADD_ADMIN_ORG: 'RESPONSE_ADD_ADMIN_ORG',
    ERROR_ADD_ADMIN_ORG: 'ERROR_ADD_ADMIN_ORG',
    DONE_ORG_ADD_ADMIN: 'DONE_ORG_ADD_ADMIN',

    //make primary admin
    REQUEST_PRIMARY_ADMIN_ORG: 'REQUEST_PRIMARY_ADMIN_ORG',
    RESPONSE_PRIMARY_ADMIN_ORG: 'RESPONSE_PRIMARY_ADMIN_ORG',
    ERROR_PRIMARY_ADMIN_ORG: 'ERROR_PRIMARY_ADMIN_ORG',

    //remove admin
    REQUEST_REMOVE_ADMIN_ORG: 'REQUEST_REMOVE_ADMIN_ORG',
    RESPONSE_REMOVE_ADMIN_ORG: 'RESPONSE_REMOVE_ADMIN_ORG',
    ERROR_REMOVE_ADMIN_ORG: 'ERROR_REMOVE_ADMIN_ORG',


    REQUEST_DELETE_ADMIN_ORG: 'REQUEST_DELETE_ADMIN_ORG',
    RESPONSE_DELETE_ADMIN_ORG: 'RESPONSE_DELETE_ADMIN_ORG',
    ERROR_DELETE_ADMIN_ORG: 'ERROR_DELETE_ADMIN_ORG',




    //Manage Batches
    REQUEST_BATCH_LIST_ORG: 'REQUEST_BATCH_LIST_ORG',
    RECEIVE_BATCH_LIST_ORG: 'RECEIVE_BATCH_LIST_ORG',
    ERROR_BATCH_LIST_ORG: 'ERROR_BATCH_LIST_ORG',

    REQUEST_ADD_BATCH_ORG: 'REQUEST_ADD_BATCH_ORG',
    RECIEVE_ADD_BATCH_ORG: 'RECIEVE_ADD_BATCH_ORG',
    ERROR_ADD_BATCH_ORG: 'ERROR_ADD_BATCH_ORG',

    REQUEST_DELETE_BATCH_ORG: 'REQUEST_DELETE_BATCH_ORG',
    RECIEVE_DELETE_BATCH_ORG: 'RECIEVE_DELETE_BATCH_ORG',
    ERROR_DELETE_BATCH_ORG: 'ERROR_DELETE_BATCH_ORG',

    REQUEST_BATCH_DETAILS: 'REQUEST_BATCH_DETAILS',
    RECIEVE_BATCH_DETAILS: 'RECIEVE_BATCH_DETAILS',
    ERROR_BATCH_DETAILS: 'ERROR_BATCH_DETAILS',

    REQUEST_ALLOTED_UNALLOTED_DETAILS: 'REQUEST_ALLOTED_UNALLOTED_DETAILS',
    RECIEVE_ALLOTED_UNALLOTED_DETAILS: 'RECIEVE_ALLOTED_UNALLOTED_DETAILS',
    ERROR_ALLOTED_UNALLOTED_DETAILS: 'ERROR_ALLOTED_UNALLOTED_DETAILS',

    REQUEST_UPDATE_MIN_RES: 'REQUEST_UPDATE_MIN_RES',
    RECEIVE_UPDATE_MIN_RES: 'RECEIVE_UPDATE_MIN_RES',
    ERROR_UPDATE_MIN_RES: 'ERROR_UPDATE_MIN_RES',

    REQUEST_PARTICIPANTS_LIST: "REQUEST_PARTICIPANTS_LIST",
    RESPONSE_PARTICIPANTS_LIST: "RESPONSE_PARTICIPANTS_LIST",
    ERROR_PARTICIPANTS_LIST: "ERROR_PARTICIPANTS_LIST",

    REQUEST_All_ASSESSMENT: "REQUEST_All_ASSESSMENT",
    RESPONSE_All_ASSESSMENT: "RESPONSE_All_ASSESSMENT",
    ERROR_All_ASSESSMENT: "ERROR_All_ASSESSMENT",

    REQUEST_ADD_PARTICIPENTS: "REQUEST_ADD_PARTICIPENTS",
    RESPONSE_ADD_PARTICIPENTS: "RESPONSE_ADD_PARTICIPENTS",
    ERROR_ADD_PARTICIPENTS: "ERROR_ADD_PARTICIPENTS",
    CLEAR_ADD_PARTICIPENTS: 'CLEAR_ADD_PARTICIPENTS',

    REQUEST_ENABLE_PI: "REQUEST_ENABLE_PI",
    RESPONSE_ENABLE_PI: "RESPONSE_ENABLE_PI",
    ERROR_ENABLE_PI: "ERROR_ENABLE_PI",

    REQUEST_DISABLE_PI: "REQUEST_DISABLE_PI",
    RESPONSE_DISABLE_PI: "RESPONSE_DISABLE_PI",
    ERROR_DISABLE_PI: "ERROR_DISABLE_PI",

    REQUEST_ORG_MANDATE: "REQUEST_ORG_MANDATE",
    RESPONSE_ORG_MANDATE: "RESPONSE_ORG_MANDATE",
    ERROR_ORG_MANDATE: "ERROR_ORG_MANDATE",

    REQUEST_ALLOT_BATCH: "REQUEST_ALLOT_BATCH",
    RESPONSE_ALLOT_BATCH: "RESPONSE_ALLOT_BATCH",
    ERROR_ALLOT_BATCH: "ERROR_ALLOT_BATCH",

    REQUEST_REMOVE_FROM_BATCH: "REQUEST_REMOVE_FROM_BATCH",
    RESPONSE_REMOVE_FROM_BATCH: "RESPONSE_REMOVE_FROM_BATCH",
    ERROR_REMOVE_FROM_BATCH: "ERROR_REMOVE_FROM_BATCH",

    REQUEST_ENABLE_REPORT: "REQUEST_ENABLE_REPORT",
    RESPONSE_ENABLE_REPORT: "RESPONSE_ENABLE_REPORT",
    ERROR_ENABLE_REPORT: "ERROR_ENABLE_REPORT",

    REQUEST_DISABLE_REPORT: "REQUEST_DISABLE_REPORT",
    RESPONSE_DISABLE_REPORT: "RESPONSE_DISABLE_REPORT",
    ERROR_DISABLE_REPORT: "ERROR_DISABLE_REPORT",

    REQUEST_SET_EXPIRY: "REQUEST_SET_EXPIRY",
    RESPONSE_SET_EXPIRY: "RESPONSE_SET_EXPIRY",
    ERROR_SET_EXPIRY: "ERROR_SET_EXPIRY",

    REQUEST_SET_REPORT_THEME: "REQUEST_SET_REPORT_THEME",
    RESPONSE_SET_REPORT_THEME: "RESPONSE_SET_REPORT_THEME",
    ERROR_SET_REPORT_THEME: "ERROR_SET_REPORT_THEME",

    REQUEST_DELETE_REPORT: "REQUEST_DELETE_REPORT",
    RESPONSE_DELETE_REPORT: "RESPONSE_DELETE_REPORT",
    ERROR_DELETE_REPORT: "ERROR_DELETE_REPORT",

    REQUEST_UNSUBMITTED_ASSESSMENT: "REQUEST_UNSUBMITTED_ASSESSMENT",
    RESPONSE_UNSUBMITTED_ASSESSMENT: "RESPONSE_UNSUBMITTED_ASSESSMENT",
    ERROR_UNSUBMITTED_ASSESSMENT: "ERROR_UNSUBMITTED_ASSESSMENT",

    REQUEST_GET_THEME_REPORT: "REQUEST_GET_THEME_REPORT",
    RESPONSE_GET_THEME_REPORT: "RESPONSE_GET_THEME_REPORT",
    ERROR_GET_THEME_REPORT: "ERROR_GET_THEME_REPORT",

    REQUEST_INSTRUMENT_LIST: "REQUEST_INSTRUMENT_LIST",
    RESPONSE_INSTRUMENT_LIST: "RESPONSE_INSTRUMENT_LIST",
    ERROR_INSTRUMENT_LIST: "ERROR_INSTRUMENT_LIST",

    REQUEST_: "",
    RESPONSE_: "",
    ERROR_: "",

    REQUEST_SET_DEV_PLAN: 'REQUEST_SET_DEV_PLAN',
    RESPONSE_SET_DEV_PLAN: 'RESPONSE_SET_DEV_PLAN',
    ERROR_SET_DEV_PLAN: 'ERROR_SET_DEV_PLAN',

    REQUEST_GET_CUSTOM_REPORT: 'REQUEST_GET_CUSTOM_REPORT',
    RESPONSE_GET_CUSTOM_REPORT: 'RESPONSE_GET_CUSTOM_REPORT',
    ERROR_GET_CUSTOM_REPORT: 'ERROR_GET_CUSTOM_REPORT',

    REQUEST_SET_CUSTOM_REPORT: 'REQUEST_SET_CUSTOM_REPORT',
    RESPONSE_SET_CUSTOM_REPORT: 'RESPONSE_SET_CUSTOM_REPORT',
    ERROR_SET_CUSTOM_REPORT: 'ERROR_SET_CUSTOM_REPORT',

    // EDIT RELATION
    REQUEST_ORG_EDIT_RELATION: 'REQUEST_ORG_EDIT_RELATION',
    RECEIVE_ORG_EDIT_RELATION: 'RECEIVE_ORG_EDIT_RELATION',
    ORG_EDIT_RELATION_ERROR: 'ORG_EDIT_RELATION_ERROR',

    REQUEST_BATCH_ADMIN_ORG: 'REQUEST_BATCH_ADMIN_ORG',
    RESPONSE_BATCH_ADMIN_ORG: 'RESPONSE_BATCH_ADMIN_ORG',
    ERROR_BATCH_ADMIN_ORG: 'ERROR_BATCH_ADMIN_ORG',

    REQUEST_ADD_ANALYTICS_ORG_ADMIN: 'REQUEST_ADD_ANALYTICS_ORG_ADMIN',
    RESPONSE_ADD_ANALYTICS_ORG_ADMIN: 'RESPONSE_ADD_ANALYTICS_ORG_ADMIN',
    ERROR_ADD_ANALYTICS_ORG_ADMIN: 'ERROR_ADD_ANALYTICS_ORG_ADMIN',

    REQUEST_REMOVE_ANALYTICS_ORG_ADMIN: 'REQUEST_REMOVE_ANALYTICS_ORG_ADMIN',
    RESPONSE_REMOVE_ANALYTICS_ORG_ADMIN: 'RESPONSE_REMOVE_ANALYTICS_ORG_ADMIN',
    ERROR_REMOVE_ANALYTICS_ORG_ADMIN: 'ERROR_REMOVE_ANALYTICS_ORG_ADMIN',

    REQUEST_SELL_ORG_CREDITS: 'REQUEST_SELL_ORG_CREDITS',
    RESPONSE_SELL_ORG_CREDITS: 'RESPONSE_SELL_ORG_CREDITS',
    ERROR_SELL_ORG_CREDITS: 'ERROR_SELL_ORG_CREDITS',

    REQUEST_REVOKE_ORG_CREDITS: 'REQUEST_REVOKE_ORG_CREDITS',
    RESPONSE_REVOKE_ORG_CREDITS: 'RESPONSE_REVOKE_ORG_CREDITS',
    ERROR_REVOKE_ORG_CREDITS: 'ERROR_REVOKE_ORG_CREDITS',

    // REQUEST_MANAGE_METRIC_LIST
    REQUEST_MANAGE_METRIC_LIST: 'REQUEST_MANAGE_METRIC_LIST',
    RECEIVE_MANAGE_METRIC_LIST: 'RECEIVE_MANAGE_METRIC_LIST',
    MANAGE_METRIC_LIST_ERROR: 'MANAGE_METRIC_LIST_ERROR',

    // REQUEST_ADD_MANAGE_METRIC
    REQUEST_ADD_MANAGE_METRIC: 'REQUEST_ADD_MANAGE_METRIC',
    RECEIVE_ADD_MANAGE_METRIC: 'RECEIVE_ADD_MANAGE_METRIC',
    ADD_MANAGE_METRIC_ERROR: 'ADD_MANAGE_METRIC_ERROR',

    // REQUEST_UPDATE_MANAGE_METRIC
    REQUEST_UPDATE_MANAGE_METRIC: 'REQUEST_UPDATE_MANAGE_METRIC',
    RECEIVE_UPDATE_MANAGE_METRIC: 'RECEIVE_UPDATE_MANAGE_METRIC',
    UPDATE_MANAGE_METRIC_ERROR: 'UPDATE_MANAGE_METRIC_ERROR',

    // REQUEST_DELETE_MANAGE_METRIC
    REQUEST_DELETE_MANAGE_METRIC:'REQUEST_DELETE_MANAGE_METRIC',
    RECEIVE_DELETE_MANAGE_METRIC:'RECEIVE_DELETE_MANAGE_METRIC',
    DELETE_MANAGE_METRIC_ERROR:'DELETE_MANAGE_METRIC_ERROR',


    //////////ROLE FITMENT REPORT 
    // REQUEST_GET_HOLDER_LIST_AND_ORGANISATION_COMPETENCY
    REQUEST_GET_HOLDER_LIST_AND_ORGANISATION_COMPETENCY:'REQUEST_GET_HOLDER_LIST_AND_ORGANISATION_COMPETENCY',
    RECEIVE_GET_HOLDER_LIST_AND_ORGANISATION_COMPETENCY:'RECEIVE_GET_HOLDER_LIST_AND_ORGANISATION_COMPETENCY',
    GET_HOLDER_LIST_AND_ORGANISATION_COMPETENCY_ERROR:'GET_HOLDER_LIST_AND_ORGANISATION_COMPETENCY_ERROR',

    // REQUEST_GET_ORGANISATION_FITMENTS
    REQUEST_GET_ORGANISATION_FITMENTS:'REQUEST_GET_ORGANISATION_FITMENTS',
    RECEIVE_GET_ORGANISATION_FITMENTS:'RECEIVE_GET_ORGANISATION_FITMENTS',
    GET_ORGANISATION_FITMENTS_ERROR:'GET_ORGANISATION_FITMENTS_ERROR',

    // REQUEST_GET_ORGANISATION_FITMENTS
    REQUEST_DELETE_ORGANISATION_FITMENTS:'REQUEST_DELETE_ORGANISATION_FITMENTS',
    RECEIVE_DELETE_ORGANISATION_FITMENTS:'RECEIVE_DELETE_ORGANISATION_FITMENTS',
    DELETE_ORGANISATION_FITMENTS_ERROR:'DELETE_ORGANISATION_FITMENTS_ERROR',

    // REQUEST_DELETE_ORGANISATION_FITMENTS_LIST
    REQUEST_GET_ORGANISATION_FITMENTS_LIST:'REQUEST_GET_ORGANISATION_FITMENTS_LIST',
    RECEIVE_GET_ORGANISATION_FITMENTS_LIST:'RECEIVE_GET_ORGANISATION_FITMENTS_LIST',
    GET_ORGANISATION_FITMENTS_LIST_ERROR:'GET_ORGANISATION_FITMENTS_LIST_ERROR',

    // REQUEST_CREATE_ORGANISATION_FITMENTS
    REQUEST_CREATE_ORGANISATION_FITMENTS:'REQUEST_CREATE_ORGANISATION_FITMENTS',
    RECEIVE_CREATE_ORGANISATION_FITMENTS:'RECEIVE_CREATE_ORGANISATION_FITMENTS',
    CREATE_ORGANISATION_FITMENTS_ERROR:'CREATE_ORGANISATION_FITMENTS_ERROR',

    // REQUEST_UPDATE_ORGANISATION_FITMENTS
    REQUEST_UPDATE_ORGANISATION_FITMENTS:'REQUEST_UPDATE_ORGANISATION_FITMENTS',
    RECEIVE_UPDATE_ORGANISATION_FITMENTS:'RECEIVE_UPDATE_ORGANISATION_FITMENTS',
    UPDATE_ORGANISATION_FITMENTS_ERROR:'UPDATE_ORGANISATION_FITMENTS_ERROR',

    // REQUEST_GET_ALLOTED_ORGANISATION_FITMENTS
    REQUEST_GET_ALLOTED_ORGANISATION_FITMENTS:'REQUEST_GET_ALLOTED_ORGANISATION_FITMENTS',
    RECEIVE_GET_ALLOTED_ORGANISATION_FITMENTS:'RECEIVE_GET_ALLOTED_ORGANISATION_FITMENTS',
    GET_ALLOTED_ORGANISATION_FITMENTS_ERROR:'GET_ALLOTED_ORGANISATION_FITMENTS_ERROR',

    // ASSESSMENT UPLOAD
    REQUEST_UPLOAD_ASSESSMENT_API: 'REQUEST_UPLOAD_ASSESSMENT_API',
    RECIEVE_UPLOAD_ASSESSMENT_API: 'RECIEVE_UPLOAD_ASSESSMENT_API',
    ERROR_UPLOAD_ASSESSMENT_API: 'ERROR_UPLOAD_ASSESSMENT_API',

    REQUEST_UPLOAD_RESPONDENT_API: 'REQUEST_UPLOAD_RESPONDENT_API',
    RECIEVE_UPLOAD_RESPONDENT_API: 'RECIEVE_UPLOAD_RESPONDENT_API',
    ERROR_UPLOAD_RESPONDENT_API: 'ERROR_UPLOAD_RESPONDENT_API',

    // ASSESSMENT RESPONSES UPLOAD
    REQUEST_UPLOAD_ASSESSMENT_RESPONSES_API: 'REQUEST_UPLOAD_ASSESSMENT_RESPONSES_API',
    RECIEVE_UPLOAD_ASSESSMENT_RESPONSES_API: 'RECIEVE_UPLOAD_ASSESSMENT_RESPONSES_API',
    ERROR_UPLOAD_ASSESSMENT_RESPONSES_API: 'ERROR_UPLOAD_ASSESSMENT_RESPONSES_API',

    // ASSESSMENT RESPONSES RESULT LIST UPLOAD
    REQUEST_UPLOAD_ASSESSMENT_RESPONSES_RESULT_LIST_API: 'REQUEST_UPLOAD_ASSESSMENT_RESPONSES_RESULT_LIST_API',
    RECIEVE_UPLOAD_ASSESSMENT_RESPONSES_RESULT_LIST_API: 'RECIEVE_UPLOAD_ASSESSMENT_RESPONSES_RESULT_LIST_API',
    ERROR_UPLOAD_ASSESSMENT_RESPONSES_RESULT_LIST_API: 'ERROR_UPLOAD_ASSESSMENT_RESPONSES_RESULT_LIST_API',

     // ASSESSMENT RESPONSES RESULT VIEW UPLOAD
     REQUEST_UPLOAD_ASSESSMENT_RESPONSES_RESULT_VIEW_API: 'REQUEST_UPLOAD_ASSESSMENT_RESPONSES_RESULT_VIEW_API',
     RECIEVE_UPLOAD_ASSESSMENT_RESPONSES_RESULT_VIEW_API: 'RECIEVE_UPLOAD_ASSESSMENT_RESPONSES_RESULT_VIEW_API',
     ERROR_UPLOAD_ASSESSMENT_RESPONSES_RESULT_VIEW_API: 'ERROR_UPLOAD_ASSESSMENT_RESPONSES_RESULT_VIEW_API',

    //Bulk download permissions
    REQUEST_ADD_BULK_DOWNLOAD_API: 'REQUEST_ADD_BULK_DOWNLOAD_API',
    RECIEVE_ADD_BULK_DOWNLOAD_API: 'RECIEVE_ADD_BULK_DOWNLOAD_API',
    ERROR_ADD_BULK_DOWNLOAD_API: 'ERROR_ADD_BULK_DOWNLOAD_API',

    REQUEST_REMOVE_BULK_DOWNLOAD_API: 'REQUEST_REMOVE_BULK_DOWNLOAD_API',
    RECIEVE_REMOVE_BULK_DOWNLOAD_API: 'RECIEVE_REMOVE_BULK_DOWNLOAD_API',
    ERROR_REMOVE_BULK_DOWNLOAD_API: 'ERROR_REMOVE_BULK_DOWNLOAD_API',

    REQUEST_CHECK_BULK_DOWNLOAD_API: 'REQUEST_CHECK_BULK_DOWNLOAD_API',
    RECIEVE_CHECK_BULK_DOWNLOAD_API: 'RECIEVE_CHECK_BULK_DOWNLOAD_API',
    ERROR_CHECK_BULK_DOWNLOAD_API: 'ERROR_CHECK_BULK_DOWNLOAD_API',

    REQUEST_REPORT_BULK_DOWNLOAD_API: 'REQUEST_REPORT_BULK_DOWNLOAD_API',
    RECIEVE_REPORT_BULK_DOWNLOAD_API: 'RECIEVE_REPORT_BULK_DOWNLOAD_API',
    ERROR_REPORT_BULK_DOWNLOAD_API: 'ERROR_REPORT_BULK_DOWNLOAD_API',


    // Add these constants
    REQUEST_RESET_ASSESSMENT: "REQUEST_RESET_ASSESSMENT",
    RESPONSE_RESET_ASSESSMENT: "RESPONSE_RESET_ASSESSMENT", 
    ERROR_RESET_ASSESSMENT: "ERROR_RESET_ASSESSMENT",



};


// WEBPACK FOOTER //
// ./src/_constants/organisation.constants.js